import React, { useEffect, useState } from "react";
import { Row, Col, Image, Modal } from "react-bootstrap";
import VideoIcon from "../../assets/images/video-line.svg";
import Edit from "../../assets/images/ic-edit.svg";
import DeleteBox from "../../assets/images/ic-deletebox.svg";
import { formatDate } from "../../constant/DateFormat";
import ENGModalHeader from "../modal/ENGModalHeader";
import ENGModalBody from "../modal/ENGModalBody";
import { isPermited } from "../../features/localStorage";
import EmptyRow from "../../components/emptyRow/EmptyRow";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { GetAwarenessModule } from "../../features/learning/AwarenessSlice";
import { GetUpdateMaterial } from "../../features/learning/updateMaterialSlice";
import { GetDeleteMaterial } from "../../features/learning/deleteMaterialSlice";
import FileUploadImage from "../textField/FileUploadImages";
import FileUpload from "../textField/FileUpload";
import ModalDelete from "../../assets/images/delete-bin-line.svg";
import { useForm } from "react-hook-form";
import { dev } from "../../features/network/ApiCall";
import { AspectRatio } from "react-aspect-ratio";
import MultiSelectCompany from "../textField/MultiSelectCompany";
import {
  GetAllCompany,
  selectAllCompany,
} from "../../features/company/companyListSlice";
import Dropdown from "../dropdown/Dropdown";
import {
  GetCategoryList,
  GetCategoryListAsync,
} from "../../features/learning/CategorySlice";
import { useParams } from "react-router-dom";

const required = "This field is required";
const maxLength = "Your input exceed maximum length";
// Error Component
const errorMessage = (error: any) => {
  return <div className="invalid-feedback">{error}</div>;
};
const VideoItemAdmin = ({
  item,
  columns = 4,
}: {
  item: any;
  columns: number;
}) => {
  const params = useParams();
  const { categoryId }: any = params;

  const [modalShow, setModalShow] = useState(false);
  const handleClose = () => setModalShow(false);
  const allCompany = useAppSelector(selectAllCompany);
  const [selectedId, setSelectedId] = useState([]);
  const [buid, setBuId] = useState<any>(item.buid);
  const [sectorId, setSectorId] = useState<any>(item.sectorId);
  const [companyId, setCompanyId] = useState([selectedId]);
  const dispatch = useAppDispatch();
  const [ofset, setOfset] = useState(0);
  const [titleFeild, setTitle] = useState(item.title);
  const [file, setFile] = useState("");
  const [thumbnail, setthumbnail] = useState(item.thumbnail);
  const [materialId, setMaterialId] = useState();
  const [description, setDescription] = useState(item.discription);
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);
  const isAdmin = localStorage.getItem("isAdmin");
  const isAdminList: any = isAdmin;
  const isAdminJson = JSON.parse(isAdminList);
  const [pasteLink, setPasteLink] = useState(true);
  const [modalShow1, setModalShow1] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState<any>();
  const [paste, setPaste] = useState(item.externalUrl);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [category, setCategory] = useState("");
  const handleClose1 = () => setModalShow1(false);
  var searchParams: any;
  const handleShow = (item: any) => {
    setModalShow(true);
    setMaterialId(item.id);
    setTitle(item.title);
    setDescription(item.description);
    setFile(item.materialPath);
    setCompanyId(item.companyId);
    setPaste(item.externalUrl);
    setSelectedCompany(item?.companyId);
    if (isAdminJson === false) {
      // call non sso comapny with id
      const fetchCompany = async () => {
        await dispatch(
          GetAllCompany(
            (searchParams = { type: 2, id: userDetailsJson.companyId })
          )
        );
      };
      fetchCompany();
    } else {
      // call sso +non sso company
      const fetchAllComany = async () => {
        await dispatch(GetAllCompany((searchParams = { type: "", id: 0 })));
      };
      fetchAllComany();
    }
  };
  // Modal Code end

  useEffect(() => {
    if (categoryId) {
      setCategory(categoryId);
    }
  }, [categoryId]);

  const { register, handleSubmit, errors } = useForm();
  const onSubmit = async (event: any) => {
    //event.preventDefault();
    var postdata;

    var setBuid = buid.toString();
    var setSectorId = sectorId.toString();
    var setCompnayId = companyId.toString();
    postdata = {
      title: titleFeild,
      moduleId: 3,
      description: description,
      mediaType: "Documents",
      thumbnail: thumbnail,
      materialPath: file,
      externalUrl: paste,
      moduleType: "Learning Modules",
      companyId: setCompnayId,
      buid: setBuid,
      sectorId: setSectorId,
    };

    var data = {
      data: postdata,
      id: materialId,
    };
    await dispatch(GetUpdateMaterial(data));
    var getdata = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
    };
    dispatch(GetAwarenessModule(getdata));
    handleClose();
  };
  const onDeleteModalShow = (item: any) => {
    setModalShow1(true);
    setDeleteDetails(item);
  };
  const onDeleteRecord = async (item: any) => {
    await dispatch(GetDeleteMaterial(deleteDetails.id));
    var getdata = {
      keyword: "",
      offset: 0,
    };
    await dispatch(GetAwarenessModule(getdata));
    await window.location.reload();
  };

  const handleChangeCheckbox1 = (e: any) => {
    setPasteLink(true);
  };
  const handleChangeCheckbox2 = (e: any) => {
    setPasteLink(false);
  };

  const categoryList = useAppSelector(GetCategoryList);
  const [dataList, setDataList] = useState<any>([]);

  useEffect(() => {
    dispatch(GetCategoryListAsync());
  }, []);

  useEffect(() => {
    if (categoryList?.length > 0) {
      let list: any = [];
      // let categoryDropdown: any = [];
      categoryList?.map((val: any) => {
        let obj = {
          id: val?.id,
          name: val?.categoryName,
          title: val?.categoryName,
          description: val?.categoryDescription,
          externalUrl: `/learning/${val?.id}`,
        };
        list = [...list, obj];
      });
      setDataList([...list]);
    }
  }, [categoryList]);

  return (
    <>
      <Col
        lg={columns}
        md={columns}
        sm={columns}
        style={{ marginBottom: "20px" }}
      >
        <div className="b_shadow" style={{ backgroundColor: "#fff" }}>
          <AspectRatio ratio="3/4" style={{ maxWidth: "100%" }}>
            <Image
              src={`${dev}/admin/download?fileName=${item.thumbnail}`}
              style={{ width: "100%" }}
            />
          </AspectRatio>
          <div className="p10_all">
            <h3 style={styles.title}>{item.title}</h3>
            <p style={styles.contents}>
              {formatDate(item.updatedDate)}

              <Row>
                <Col sm={10}>
                  {isPermited(7, 3) && (
                    <a onClick={() => handleShow(item)}>
                      <span style={styles.editstyle}>
                        <Image src={Edit} />
                      </span>
                    </a>
                  )}
                  <Modal
                    show={modalShow}
                    onHide={handleClose}
                    backdrop="static"
                    size="lg"
                    keyboard={false}
                  >
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <ENGModalHeader icon={VideoIcon} title=" Edit Video " />
                      <ENGModalBody
                        contents={
                          <>
                            {/* <Row style={styles.divWhite}>
                              <Col lg={6}>
                                <label htmlFor="sector">Select Sector</label> */}
                            {/* <Multiselect
                                    options={SectorList}
                                    onSelect={onSelectSector}
                                    onRemove={onRemoveSector}
                                    ref={ref}
                                    name="teammember"
                                    displayValue="name"
                                    showCheckbox={true}
                                    selectedValues={preSelectedValues}
                                />    */}
                            {/* <MultiSelectCheck
                                  SectorList={SectorList}
                                  setSectorId={setSectorId}
                                  preSelectedValue={item.sectorId}
                                />
                              </Col> */}
                            {/* <Col lg={6}>
                                <label htmlFor="Unit">
                                  Select Business Unit
                                </label> */}
                            {/* <Multiselect
                                    options={BusinessUnitList}
                                    onSelect={onSelectBu}
                                    onRemove={onRemoveBu}
                                    ref={ref}
                                    name="teammember"
                                    displayValue="name"
                                    showCheckbox={true}
                                    selectedValues={preSelectedValues}
                                />    */}
                            {/* <MultiSelectCheckBu
                                  SectorList={BusinessUnitList}
                                  setBuId={setBuId}
                                  selectedId={item.buid}
                                />
                              </Col> */}
                            {/* </Row> */}

                            <Row style={styles.divWhite}>
                              <Col lg={12}>
                                <input
                                  type="radio"
                                  name="videobutton"
                                  onClick={handleChangeCheckbox1}
                                  id="name"
                                  defaultChecked={true}
                                />
                                Paste URL &nbsp;&nbsp;
                                <input
                                  type="radio"
                                  onClick={handleChangeCheckbox2}
                                  name="videobutton"
                                  id="rollno"
                                />
                                Upload Video
                              </Col>
                            </Row>
                            <form>
                              <Row style={styles.divWhite}>
                                <Row>
                                  <Col sm={12} className="desk">
                                    <Dropdown
                                      id="Category"
                                      data={dataList}
                                      value={category}
                                      onchange={setCategory}
                                    />
                                  </Col>
                                  <EmptyRow />
                                  <Col sm={12}>
                                    <div className="floating-label-group">
                                      <input
                                        type="text"
                                        name="title"
                                        ref={register({ required: true })}
                                        defaultValue={item.title}
                                        onChange={(
                                          ev: React.ChangeEvent<HTMLInputElement>
                                        ): void => setTitle(ev.target.value)}
                                        className="textstyle"
                                      />
                                      <label className="floating-label">
                                        Title{" "}
                                        <span style={styles.star}> * </span>
                                      </label>
                                    </div>
                                    {errors.title &&
                                      errors.title.type === "required" &&
                                      errorMessage(required)}
                                  </Col>
                                </Row>
                                <EmptyRow />
                                <Row>
                                  {pasteLink === true ? (
                                    <Col sm={6}>
                                      <div className="floating-label-group">
                                        <input
                                          type="text"
                                          name="paste"
                                          defaultValue={item.externalUrl}
                                          ref={register({ required: true })}
                                          onChange={(
                                            ev: React.ChangeEvent<HTMLInputElement>
                                          ): void => setPaste(ev.target.value)}
                                          className="textstyle"
                                        />
                                        <label className="floating-label">
                                          Paste URL{" "}
                                          <span style={styles.star}> * </span>
                                        </label>
                                      </div>
                                      {errors.paste &&
                                        errors.paste.type === "required" &&
                                        errorMessage(required)}
                                    </Col>
                                  ) : (
                                    <Col sm={6}>
                                      <FileUpload
                                        setFile={setFile}
                                        title="Upload Video"
                                        fileValue={item.externalUrl}
                                        fileType="MP4"
                                      />
                                    </Col>
                                  )}
                                  <Col sm={6}>
                                    <FileUploadImage
                                      setFile={setthumbnail}
                                      title="Thumbnail"
                                      fileValue={item.thumbnail}
                                      fileType="JPG/JPEG/PNG"
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <label htmlFor="Unit">Accessible To</label>
                                    {/* <MultiSelectCompany SectorList={allCompany} setCompanyId={setCompanyId} selectedId={item.companyId}/> */}
                                    <MultiSelectCompany
                                      optionList={allCompany}
                                      setId={setCompanyId}
                                      selectedValue={selectedCompany}
                                      valueKey="id"
                                      labelKey="company"
                                      isAdd={false}
                                    />
                                  </Col>
                                </Row>
                              </Row>
                            </form>
                          </>
                        }
                      />
                      <EmptyRow />
                      <EmptyRow />
                      <Row style={styles.divGrey}>
                        <Col sm={9}></Col>
                        <Col sm={3}>
                          <button
                            type="button"
                            onClick={handleClose}
                            style={styles.button1}
                          >
                            {" "}
                            CANCEL{" "}
                          </button>
                          <button type="submit" style={styles.button}>
                            {" "}
                            SAVE{" "}
                          </button>
                        </Col>
                      </Row>
                    </form>
                  </Modal>
                </Col>

                <Col sm={2}>
                  <span
                    onClick={() => onDeleteModalShow(item)}
                    style={styles.editstyle}
                  >
                    <Image src={DeleteBox} />
                  </span>
                </Col>
              </Row>

              <Modal
                show={modalShow1}
                onHide={handleClose1}
                backdrop="static"
                size="lg"
                keyboard={false}
              >
                <ENGModalHeader icon={ModalDelete} title=" Delete Module " />
                <ENGModalBody
                  contents={
                    <>
                      <Row style={styles.divWhite}>
                        <Col lg={12}>
                          <p style={styles.delcontent}>
                            Are you sure you want delete this module?
                          </p>
                        </Col>
                      </Row>
                    </>
                  }
                />
                <EmptyRow />
                <EmptyRow />
                <EmptyRow />
                <EmptyRow />
                <Row style={styles.divGrey}>
                  <Col sm={9}></Col>
                  <Col sm={3}>
                    <button
                      type="button"
                      className="mr-2"
                      onClick={handleClose1}
                      style={styles.button1}
                    >
                      {" "}
                      CANCEL{" "}
                    </button>
                    <button
                      className="ml-2"
                      type="button"
                      onClick={onDeleteRecord}
                      style={styles.button}
                    >
                      {" "}
                      DELETE{" "}
                    </button>
                  </Col>
                </Row>
              </Modal>
            </p>
          </div>
        </div>
      </Col>
    </>
  );
};

const styles: any = {
  selectpoperty: {
    backgroundColor: "white",
    paddingBottom: "0px",
    border: "solid 1px #e4e4e4",
    width: "100%",
    fontFamily: "Georama-Regular",
    fontSize: "16px",
    color: "#6d6e71",
    borderRadius: "0px",
  },

  backstyle: {
    color: "#e31837",
    fontFamily: "Georama-Regular",
    fontWeight: 600,
    fontSize: "12px",
    marginTop: "10px",
  },
  editstyle: {
    color: "#e31837",
    fontFamily: "Georama-Regular",
    fontWeight: 600,
    fontSize: "12px",
    float: "right",
  },

  divWhite: {
    backgroundColor: "#fffff",
    paddingTop: "20px",
    paddingLeft: "20px",
    paddingRight: "20px",
  },

  button: {
    padding: "13px 20px",
    fontFamily: "Georama-Regular",
    fontSize: "12px",
    fontWeight: 400,
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#e31837",
    letterSpacing: "normal",
    border: "0px",
    color: "#fff",
    float: "right",
  },
  button1: {
    padding: "13px 15px",
    fontFamily: "Georama-Regular",
    fontSize: "12px",
    fontWeight: "500",
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#ffffff",
    border: "1px solid #e31837",
    letterSpacing: "normal",
    color: "#e31837",
  },
  divGrey: {
    backgroundColor: "rgb(250, 249, 249)",
    paddingTop: "20px",
    margin: "0px",
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingBottom: "20px",
    borderTop: "1px solid #eee;",
  },

  delb: {
    float: "right",
    color: "#db233a",
    fontSize: "12px",
  },

  img1: {
    width: "80%",
  },
  title: {
    fontFamily: "Georama-Regular",
    fontSize: "18px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.44,
    letterSpacing: "normal",
  },

  contents: {
    color: "#6d6e71",
    fontFamily: "Georama-Regular",
    fontSize: "14px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.57,
    letterSpacing: "normal",
  },
};

export default VideoItemAdmin;
